


















































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import CategoryTable from './tables/CategoryTable.vue';
import Category from './tables/category';
import gql from 'graphql-tag';

import * as BOX_STYLES_QUERY from 'src/graphql/admin/BoxStyles.graphql';

import * as FOOD_TYPES_QUERY       from 'src/graphql/admin/FoodTypes.graphql';
import * as CREATE_FOOD_TYPE_QUERY from 'src/graphql/admin/CreateFoodType.graphql';
import * as EDIT_FOOD_TYPE_QUERY   from 'src/graphql/admin/EditFoodType.graphql';
import * as DELETE_FOOD_TYPE_QUERY from 'src/graphql/admin/DeleteFoodType.graphql';

import * as PACKAGING_SYSTEMS_QUERY       from 'src/graphql/admin/PackagingSystems.graphql';
import * as CREATE_PACKAGING_SYSTEM_QUERY from 'src/graphql/admin/CreatePackagingSystem.graphql';
import * as EDIT_PACKAGING_SYSTEM_QUERY   from 'src/graphql/admin/EditPackagingSystem.graphql';
import * as DELETE_PACKAGING_SYSTEM_QUERY from 'src/graphql/admin/DeletePackagingSystem.graphql';

import * as STORAGE_CONDITIONS_QUERY       from 'src/graphql/admin/StorageConditions.graphql';
import * as CREATE_STORAGE_CONDITION_QUERY from 'src/graphql/admin/CreateStorageCondition.graphql';
import * as EDIT_STORAGE_CONDITION_QUERY   from 'src/graphql/admin/EditStorageCondition.graphql';
import * as DELETE_STORAGE_CONDITION_QUERY from 'src/graphql/admin/DeleteStorageCondition.graphql';

import * as DESTINATIONS_QUERY       from 'src/graphql/admin/Destinations.graphql';
import * as CREATE_DESTINATION_QUERY from 'src/graphql/admin/CreateDestination.graphql';
import * as EDIT_DESTINATION_QUERY   from 'src/graphql/admin/EditDestination.graphql';
import * as DELETE_DESTINATION_QUERY from 'src/graphql/admin/DeleteDestination.graphql';

import * as PLANTS_QUERY       from 'src/graphql/admin/Plants.graphql';
import * as CREATE_PLANT_QUERY from 'src/graphql/admin/CreatePlant.graphql';
import * as EDIT_PLANT_QUERY   from 'src/graphql/admin/EditPlant.graphql';
import * as DELETE_PLANT_QUERY from 'src/graphql/admin/DeletePlant.graphql';

import * as SIMULATION_PARAMETERS_QUERY from 'src/graphql/admin/SimulationParameters.graphql';
import * as SET_SIMULATION_PARAMETER_QUERY from 'src/graphql/admin/SetSimulationParameter.graphql';

@Component({
  components: {
    CategoryTable,
  },
  apollo: {
    food_types: {
      query: FOOD_TYPES_QUERY,
      fetchPolicy: 'cache-and-network',
      watchLoading(isLoading, countModifier) {
        this.foodTypesCategory.loading = isLoading;
      },
    },
    packaging_systems: {
      query: PACKAGING_SYSTEMS_QUERY,
      fetchPolicy: 'cache-and-network',
      watchLoading(isLoading, countModifier) {
        this.packagingSystemsCategory.loading = isLoading;
      },
    },
    storage_conditions: {
      query: STORAGE_CONDITIONS_QUERY,
      fetchPolicy: 'cache-and-network',
      watchLoading(isLoading, countModifier) {
        this.storageConditionsCategory.loading = isLoading;
      },
    },
    destinations: {
      query: DESTINATIONS_QUERY,
      fetchPolicy: 'cache-and-network',
      watchLoading(isLoading, countModifier) {
        this.destinationsCategory.loading = isLoading;
      },
    },
    plants: {
      query: PLANTS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
    simulation_parameters: {
      query: SIMULATION_PARAMETERS_QUERY,
      fetchPolicy: 'cache-and-network',
    }
  }
})
export default class extends Vue {
  boardProductionCarbonFootprint    = { id: -1, value: null };
  defaultDestinationCarbonFootprint = { id: -1, value: null };

  carbonDialog = false;
  carbonValid = true;
  carbonParameter = { id: -1, value: 0 };
  carbonFormTitle = '';
  carbonWarning = '';
  carbonHint = '';
  carbonEditBoardProductionFootprint = true;

  savingAs = false;
  deleteDialog = false;

  food_types = [];
  foodTypesCategory = Category.restore({
    name: 'Type',
    type: 'FoodType',
    headers: [
      { text: 'Food Type', value: 'name' },
      { text: 'Risk',      value: 'risk' },
    ],
    values: this.food_types,
    loading: true,
    pagination: { sortBy: 'risk', descending: true },
    createQuery:     CREATE_FOOD_TYPE_QUERY,
    createAttribute: 'createFoodType',
    editQuery:       EDIT_FOOD_TYPE_QUERY,
    editAttribute:   'editFoodType',
    deleteQuery:     DELETE_FOOD_TYPE_QUERY,
    deleteAttribute: 'deleteFoodType',
    listQuery:       FOOD_TYPES_QUERY,
    listAttribute:   'food_types',
    valueAttribute:  'risk',
  });

  packaging_systems = [];
  packagingSystemsCategory = Category.restore({
    name: 'Packaging',
    type: 'PackagingSystem',
    headers: [
      { text: 'Packaging System', value: 'name' },
      { text: 'Risk',             value: 'risk' },
    ],
    values: this.packaging_systems,
    loading: true,
    pagination: { sortBy: 'risk', descending: true },
    createQuery:     CREATE_PACKAGING_SYSTEM_QUERY,
    createAttribute: 'createPackagingSystem',
    editQuery:       EDIT_PACKAGING_SYSTEM_QUERY,
    editAttribute:   'editPackagingSystem',
    deleteQuery:     DELETE_PACKAGING_SYSTEM_QUERY,
    deleteAttribute: 'deletePackagingSystem',
    listQuery:       PACKAGING_SYSTEMS_QUERY,
    listAttribute:   'packaging_systems',
    valueAttribute:  'risk',
  });

  storage_conditions = [];
  storageConditionsCategory = Category.restore({
    name: 'Storage',
    type: 'StorageCondition',
    headers: [
      { text: 'Storage Condition', value: 'name' },
      { text: 'Risk',              value: 'risk' },
    ],
    values: this.storage_conditions,
    loading: true,
    createQuery:     CREATE_STORAGE_CONDITION_QUERY,
    createAttribute: 'createStorageCondition',
    editQuery:       EDIT_STORAGE_CONDITION_QUERY,
    editAttribute:   'editStorageCondition',
    deleteQuery:     DELETE_STORAGE_CONDITION_QUERY,
    deleteAttribute: 'deleteStorageCondition',
    listQuery:       STORAGE_CONDITIONS_QUERY,
    listAttribute:   'storage_conditions',
    valueName:       'Risk',
    valueAttribute:  'risk',
  });

  destinations = [];
  destinationsCategory = Category.restore({
    name: 'Destination',
    type: 'Destination',
    headers: [
      { text: 'Destination',      value: 'name' },
      { text: 'Total kg CO₂/ton', value: 'co2' },
    ],
    values: this.destinations,
    loading: true,
    createQuery:        CREATE_DESTINATION_QUERY,
    createAttribute:    'createDestination',
    editQuery:          EDIT_DESTINATION_QUERY,
    editAttribute:      'editDestination',
    deleteQuery:        DELETE_DESTINATION_QUERY,
    deleteAttribute:    'deleteDestination',
    deleteRefetchQuery: PLANTS_QUERY,
    listQuery:          DESTINATIONS_QUERY,
    listAttribute:      'destinations',
    valueName:          'Total kg CO₂/ton',
    valueAttribute:     'co2',
    rowsPerPageItems:   [15],
    hideActions:        false,
    deleteDialogWidth:  350,
    deleteWarning:      'Deleting a destination also deletes the plants connected to the destination.',
  });

  plants = [];
  plantHeaders = [
    { text: 'Plant',       value: 'name' },
    { text: 'Destination', value: 'destination' },
  ];

  plantSearch = '';
  plantDialog = false;
  plantValid = true;
  plantEditedIndex = -1;

  plantEditedItem = {
    id: -1,
    name: "",
    destination: {
      id: -1,
      name: "",
    },
  };

  plantDefaultItem = {
    id: -1,
    name: "",
    destination: {
      id: -1,
      name: "",
    },
  };

  simulation_parameters = [];

  nameRules = [
    v => !!v || 'This field is required',
    v => this.checkUniquePlantName(v),
  ];

  requiredRules = [
    v => !!v || 'This field is required',
  ];

  @Watch('food_types')
  onFoodTypesChanged() {
    this.foodTypesCategory.values = this.food_types;
  }

  @Watch('packaging_systems')
  onPackagingSystemsChanged() {
    this.packagingSystemsCategory.values = this.packaging_systems;
  }

  @Watch('storage_conditions')
  onStorageConditionsChanged() {
    this.storageConditionsCategory.values = this.storage_conditions;
  }

  @Watch('destinations')
  onDestinationsChanged() {
    this.destinationsCategory.values = this.destinations;
  }

  @Watch('simulation_parameters')
  onSimulationParametersChanged() {
    this.boardProductionCarbonFootprint    = _.pick(this.simulation_parameters.find( dbValue => dbValue.name === 'BoardProductionCarbonFootprint' ),    ['id', 'value']);
    this.defaultDestinationCarbonFootprint = _.pick(this.simulation_parameters.find( dbValue => dbValue.name === 'DefaultDestinationCarbonFootprint' ), ['id', 'value']);
  }


  checkUniquePlantName(name) {
    if (this.plantEditedIndex != -1 && !this.savingAs)
      return true;

    if (name == null)
      return false;

    const found = this.plants.some( plant => plant.name.toLowerCase() === name.toLowerCase() );
    console.log(`Found plant ${name}: ${found}`);
    return !found || 'Plant already exists';
  }

  get plantFormTitle () {
    return this.plantEditedIndex === -1 ? 'New plant' : 'Edit plant';
  }

  plantEditItem(item) {
    this.plantEditedIndex = this.plants.indexOf(item);
    this.plantEditedItem = Object.assign({}, item);
    this.plantEditedItem.destination = this.destinations.find( dbValue => dbValue.id == this.plantEditedItem.destination.id );
    this.plantDialog = true;
  }

  plantClose() {
    this.plantDialog = false;

    setTimeout(() => {
      this.plantEditedItem = Object.assign({}, this.plantDefaultItem);
      this.plantEditedIndex = -1;
    }, 300)
  }

  plantSave() {
    const form = this.$refs.plantForm as any;
    if (!form.validate()) {
      return;
    }

    if (this.plantEditedIndex > -1) {
      this.editPlant();
    } else {
      this.createPlant();
    }

    this.plantClose();
  }

  closeDelete() {
    this.deleteDialog = false;
  }

  deletePlant() {
    this.$apollo.mutate({
      mutation: DELETE_PLANT_QUERY,
      variables: { id: this.plantEditedItem.id },
      update: (store, {data: { deletePlant }}) => {
        let data: any = store.readQuery({
          query: PLANTS_QUERY,
        });

        data.plants = data.plants.filter(
          plant => plant.id !== deletePlant
        );

        store.writeQuery({
          query: PLANTS_QUERY,
          data
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        deletePlant: this.plantEditedItem.id,
      },
    });

    this.closeDelete();
    this.plantClose();
  }

  createPlant() {
    const inputPlant              = _.omit(this.plantEditedItem,             ['__typename', 'id', 'destination.__typename']);
    const inputPlantNoDestination = _.omit(this.plantEditedItem,             ['__typename', 'id', 'destination']);
    const inputDestination        = _.omit(this.plantEditedItem.destination, ['__typename']);

    this.$apollo.mutate({
      mutation: CREATE_PLANT_QUERY,
      variables: { input: inputPlant },
      update: (store, {data: { createPlant }}) => {
        let data: any = store.readQuery({
          query: PLANTS_QUERY,
        });

        data.plants.push(createPlant);

        store.writeQuery({
          query: PLANTS_QUERY,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        createPlant: {
          __typename: 'Plant',
          id: -1,
          ...inputPlantNoDestination,
          destination: {
            __typename: 'Destination',
            ...inputDestination,
          }
        },
      },
    });
  }

  editPlant() {
    const inputPlant              = _.omit(this.plantEditedItem,             ['__typename', 'destination.__typename']);
    const inputPlantNoDestination = _.omit(this.plantEditedItem,             ['__typename', 'destination']);
    const inputDestination        = _.omit(this.plantEditedItem.destination, ['__typename']);

    this.$apollo.mutate({
      mutation: EDIT_PLANT_QUERY,
      variables: { input: inputPlant },
      update: (store, {data: { editPlant }}) => {
        let data: any = store.readQuery({
          query: PLANTS_QUERY,
        });

        data.plants = data.plants.filter(
          plant => plant.id !== this.plantEditedItem.id
        );

        data.plants.push(editPlant);

        store.writeQuery({
          query: PLANTS_QUERY,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        editPlant: {
          __typename: 'Plant',
          ...inputPlantNoDestination,
          destination: {
            __typename: 'Destination',
            ...inputDestination,
          }
        },
      },
    });
  }

  showEditBoardProductionCarbonFootprint() {
    this.carbonParameter = _.clone(this.boardProductionCarbonFootprint);
    this.carbonFormTitle = 'Corrugated Production Footprint';
    this.carbonWarning = 'Changing this value makes every simulation result outdated.';
    this.carbonHint = 'Global value for all simulations';
    this.carbonEditBoardProductionFootprint = true;

    this.carbonDialog = true;
  }

  showEditDefaultDestinationCarbonFootprint() {
    this.carbonParameter = _.clone(this.defaultDestinationCarbonFootprint);
    this.carbonFormTitle = 'Default Destination Footprint';
    this.carbonWarning = 'Changing this value makes every simulation result without SCA papers outdated.';
    this.carbonHint = 'This is only used for non-SCA papers';
    this.carbonEditBoardProductionFootprint = false;

    this.carbonDialog = true;
  }

  carbonClose() {
    this.carbonDialog = false;
  }

  carbonSave() {
    const form = this.$refs.carbonForm as any;
    if (!form.validate()) {
      return;
    }

    if (this.carbonEditBoardProductionFootprint) {
      if (this.carbonParameter.value != this.boardProductionCarbonFootprint.value)
        this.setSimulationParameter(this.carbonParameter.id, 'BoardProductionCarbonFootprint',    this.carbonParameter.value);
    } else {
      if (this.carbonParameter.value != this.defaultDestinationCarbonFootprint.value)
        this.setSimulationParameter(this.carbonParameter.id, 'DefaultDestinationCarbonFootprint', this.carbonParameter.value);
    }

    this.carbonClose();
  }

  setSimulationParameter(id, name, value) {
    this.$apollo.mutate({
      mutation: SET_SIMULATION_PARAMETER_QUERY,
      variables: {
        input: {
          name,
          value,
        }
      },
      update: (store, {data: { setSimulationParameter }}) => {
        let data: any = store.readQuery({
          query: SIMULATION_PARAMETERS_QUERY,
        });

        data.simulation_parameters = data.simulation_parameters.filter(
          parameter => parameter.id !== id
        );

        data.simulation_parameters.push(setSimulationParameter);

        store.writeQuery({
          query: SIMULATION_PARAMETERS_QUERY,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        setSimulationParameter: {
          __typename: 'SimulationParameter',
          id,
          name,
          value,
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/FoodSafetyAndCarbonFootprint.vue